import * as _ from 'underscore'

export interface IIconSet  {
	Action: string;
	Add: string;
	Cancel: string;
	Delete: string;
	Edit: string;
	New: string;
	Ok: string;
	Save: string;
	SomeChildSelected: string; 
}; 

export var IconSet: IIconSet = _.extend({}, IconSet, {
	Action: 'hehe-icons-actions',
	Add: 'hehe-icons-plus',
	Cancel: 'hehe-icons-cancel',
	Delete: 'hehe-icons-delete',
	Edit: 'hehe-icons-editpen',
	New: 'hehe-icons-form',
	Ok: 'hehe-icons-check',
	Save: 'hehe-icons-save',
	SomeChildSelected: 'mapp-studio-icons-android-checkbox-blank' 
});